import axios from '../request/http';


const businessShare = {
    businessShareList(params) {
        return axios.get("/admin/order-management/businessShare/list", {params});
    },
    // 导出文件
    productFile(params) {
        return axios.get("/admin/order-management/businessShare/download", {params,responseType:'arraybuffer'});
    },
}

export default businessShare;


// WEBPACK FOOTER //
// ./src/api/businessShare.js